<template>
    <div v-on:scroll="handleScroll">
        <Navbar :color="color" :logo="logo" :key="color"/>
        <b-container fluid id="inicio" class="banner">
            <b-row class="banner-section">
                <b-col align-self="center" md="6" lg="7" sm="12">
                    <h2>Redefinimos la<br> experiencia de vivir</h2>
                    <p>Diseñamos espacios modernos y funcionales que reflejan tus aspiraciones, combinando estilo, comodidad y calidad constructiva para ofrecer una calidad de vida excepcional</p>
                    <b-button class="btn-proyecto" :href="$router.resolve({ name: 'proyectos' }).href">Proyectos</b-button>
                </b-col>
            </b-row>
        </b-container>
        <div id="limit"></div>
        <b-container class="nosotros-section" fluid>
            <b-row class="mb-5">
                <b-col md="6" class="nosotros-col1 mb-4" align-self="center">
                    <h4>Nuestro compromiso</h4>
                    <p>Nuestro compromiso es ofrecer soluciones habitacionales que trasciendan las paredes de una vivienda, convirtiéndose en una extensión de los sueños y aspiraciones de cada uno de nuestros residentes.</p>
                    <p>Con más de 30 años de experiencia, nuestro equipo de profesionales ha logrado adaptarse y liderar con éxito las nuevas tendencias en el desarrollo de vivienda. Con pasión, profesionalismo y un espíritu colaborativo, seguimos comprometidos en ofrecer soluciones innovadoras que promueven el bienestar y mejoren la calidad de vida del mercado.</p>
                    <b-button class="btn-nosotros" :href="$router.resolve({ name: 'nosotros' }).href">Nosotros</b-button>
                </b-col>
                <b-col md="6" class="text-right pr-0" align-self="center">
                    <img class="img-fluid" src="../assets/imgs/nosotros_home.png" alt="">
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" class="pl-0 mb-4" align-self="center">
                    <img class="img-fluid" src="../assets/imgs/fotofamiliar.png" alt="">
                </b-col>
                <b-col md="6" class="nosotros-col2" align-self="center">
                    <h4>Nos destacamos por:</h4>
                    <p>En ARIA LIFE hemos logrado integrar valores que nos permiten mantenernos siempre separados de la monotonía inmobiliaria. Por el contrario hemos cohesionado cuatro factores que nos han permitido diferenciarnos en el mercado:</p>
                </b-col>
            </b-row>
        </b-container>
        <b-container>
            <b-row class="m-auto factores-section">
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-3" src="../assets/imgs/iconoestilo.svg" alt="">
                    <p class="mb-0"><b>Diseño Moderno y Estilo Atemporal:</b></p>
                    <p>Creaciones que armonizan con las tendencias actuales y permanecen relevantes con el paso del tiempo.</p>
                </b-col>
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-3" src="../assets/imgs/iconoubi.svg" alt="">
                    <p class="mb-0"><b>Ubicaciones Estratégicas:</b></p>
                    <p>Proyectos situados en puntos clave que combinan conectividad, comodidad y plusvalía.</p>
                </b-col>
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-5" src="../assets/imgs/iconoconfianza.svg" alt="">
                    <p class="mb-0"><b>Trayectoria y Confianza: </b></p>
                    <p> Años de experiencia respaldan nuestra reputación como un desarrollador de confianza. </p>
                </b-col>
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-3" src="../assets/imgs/iconoatencionp.svg" alt="">
                    <p class="mb-0"><b>Atención Personalizada:</b></p>
                    <p>Entendemos las necesidades únicas de nuestros clientes y trabajamos para superarlas.</p>
                </b-col>
            </b-row>
        </b-container>
        <hr>
        <b-container fluid>
            <b-row class="proyectos" >
                <b-col class="text-center" md="12">
                    <h4>Nuestros proyectos</h4>
                    <p class="m-auto text">Actualmente contamos con tres proyectos en etapas de lanzamiento y operación. Proyectos que obedecen a mercados de vivienda media, media alta y residencial. Así como llevando una cobertura geográfica integral de la oferta de vivienda en la ciudad.</p>
                </b-col>
                <b-col class="wrapper-proyectos-logos">
                    <b-row>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logosantamaria.svg" alt="">
                        </b-col>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logocoto1.svg" alt="">
                        </b-col>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logocoto2.svg" alt="">
                        </b-col>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logosamara.svg" alt="">
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="residenciales-status m-auto">
                <b-col md="6">
                    <ul>
                        <li><b>Paseos de Santa María:</b>  TERMINADO</li>
                        <li><b>Coto Sur:</b> ÚLTIMAS CASAS </li>
                    </ul>
                </b-col>
                <b-col md="6">
                    <ul>
                        <li><b>Coto Sur 2:</b> PREVENTA </li>
                        <li><b>Samara:</b> COMING SOON </li>
                    </ul>
                </b-col>
            </b-row>
            <b-row class="assets">
                <b-col class="pl-0 pr-0">
                    <VueSlickCarousel v-bind="slickOptions" :arrows="true" :dots="false">
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_home1.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_home2.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_home3.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_home4.png" alt="">
                        </div>
                    </VueSlickCarousel>
                </b-col>
            </b-row>
        </b-container>
        <Contact style="margin-top: -10px;"/>
        <div class="whatsapp">
            <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                
            </a>
            <b-button id="popover-target-1">
                <img src="../assets/imgs/whatsapp.png" alt="Whatsapp">
            </b-button>
            <b-popover target="popover-target-1" triggers="hover" placement="top">
                <b>Comunícate a:</b><br><br>
                <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                    Samara    
                </a>
                <br><br>
                <a href="https://api.whatsapp.com/send/?phone=526861924713&amp;app_absent=0" target="_blank">
                    Coto Sur 2
                </a>
            </b-popover>
        </div>
    </div>
</template>

<script>
    import Navbar from '../components/Navbar.vue'
    import Contact from '../components/Contact.vue'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: {
            VueSlickCarousel,
            Navbar,
            Contact
        },
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                },
                color: 'transparent',
                logo: require('../assets/imgs/aria_blanco.svg'),
                
            }
        },
        methods: {
            handleScroll(){
                var stop= document.querySelector('#limit');
                if(window.scrollY > stop.offsetTop){
                    this.color='light';
                    this.logo= require('../assets/imgs/aria_azul.svg');
                } else {
                    this.color='transparent';
                    this.logo= require('../assets/imgs/aria_blanco.svg');
                }
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>

<style scoped>
/* BANNER */
.banner{
  min-height: 100vh;
  color: #fff;
  background-image: url('../assets/imgs/imgbanner.png'); /* The image used */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.banner-section{
    min-height: 100vh;
    padding: 7%;
}
.banner h2{
  font-size: 50px;
  font-weight: 700;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff;
}
.btn-proyecto{
    border-radius: 10px;
    background: #fff !important;
    color: #000 !important;
    border: none !important;
    width: 181px;
    padding: 12px;
    font-size: 20px;
}

/* NOSOTROS */
.nosotros-section{
    padding-top: 7%;
    padding-bottom: 7%;
}
.nosotros-col1{
    padding-left: 8%;
}
.nosotros-col2{
    padding-left: 8%;
    padding-right: 5%;
}
.btn-nosotros{
    background: #20234A !important;
    color: #fff !important;
    font-size: 20px;
    border: none !important;
    width: 172px;
    padding: 11px;
}
.factores-section{
    max-width: 755px;
}
.assets img{
    width: 100%;
}
/* PROYECTOS */
.proyectos{
    padding: 10% 5% 5% 5%;
}
.proyectos .text{
    max-width: 800px;
    margin-bottom: 60px !important;
}
.wrapper-proyectos-logos{
    padding: 2% 10%;
    box-shadow: 0px 14px 38.7px -5px #9C9C9C4D;
    border-radius: 10px;
}
.residenciales-status ul{
    font-size: 20px;
}
.residenciales-status{
    max-width: 830px;
    padding-bottom: 115px;
}

@media (max-width: 992px) {

}
@media (max-width: 768px) {
    .banner h2{
        font-size: 40px;
    }
    /* NOSOTROS */
    .nosotros-section{
        padding-top: 10%;
        padding-bottom: 10%;
    }
}
</style>